<template>
  <d2-container>

    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
                  v-model="searchForm.serial_number"
                  placeholder="设备号/序列号"
                  style="width: 200px;"
          />
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.device_type"
                  placeholder="设备类型"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.velue"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>

    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="序列号"
      >
        <template slot-scope="scope">
          {{scope.row.serial_number}}
        </template>
      </el-table-column>

      <el-table-column
        label="设备号"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.device_number}}
        </template>
      </el-table-column>
      <el-table-column
              label="设备类型"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.device_number}}
        </template>
      </el-table-column>
      <el-table-column
              label="交易笔数"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.trade_num}}
        </template>
      </el-table-column>
      <el-table-column
              label="交易金额"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.trade_amount}}
        </template>
      </el-table-column>
      <el-table-column
              label="所属门店"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.affiliated_store}}
        </template>
      </el-table-column>
      <el-table-column
              label="所属商家"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>

      <el-table-column
              label="上级"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.father_agentname}}
        </template>
      </el-table-column>

      <el-table-column
              label="收银模式"
              v-if="is_dl_type=='4'"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.deposit_type}}
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="200"
      >
          <template slot-scope="scope">
            <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">流水清单</el-button>
            <el-button type="primary" plain  size="mini"        v-if="is_dl_type=='4'"  @click="openViewForm(scope.row)">收银模式</el-button>

          </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
          :agent="agent"
          v-model="editFormVisible"
          @submit="getTableData"
  />
    <view-form
            :agent="agent"
            v-model="viewFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import util from '@/libs/util.js'
import editForm from './editForm'
import viewForm from './viewForm'
import * as agentService from '@/api/sys/agent'
export default {
  name: 'EquipmentPage',
  components: { editForm, viewForm },
  data () {
    return {
      searchForm: {
        noticeTitle: ''
      },
      dateRange: [],
      is_dl_type: '',
      pickerOptions: {},
      loading: false,
      tableData: [],
      multipleSelection: [],
      typeOptions: [
        {
          value: '微信',
          label: '微信'
        },
        {
          value: '支付宝',
          label: '支付宝'
        },
        {
          value: '收银插件',
          label: '收银插件'
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      },
      agent: {},
      editFormVisible: false,
      viewFormVisible: false
    }
  },
  mounted () {
    this.is_dl_type = util.cookies.get('dl_type')
    this.getTableData()
  },
  methods: {
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        agentid: util.cookies.get('agentid'),
        descending: this.sort.order === 'descending',
        filter: this.searchForm
      }
      agentService.getEquipmentPagedList(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    },
    openEditForm (agent) {
      this.agent = agent
      this.editFormVisible = true
    },
    openViewForm (agent) {
      this.agent = agent
      this.editFormVisible = false
      this.viewFormVisible = true
    },
    del (noticeId) {
      let msg = '删除'
      this.$confirm('确认' + msg + '操作？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: '取消'
      }).then(() => {
        noticeService.delNotice({ noticeId: noticeId }).then(() => {
          this.getTableData()
        })
      })
    }
  }
}
</script>
